export default "__VITE_ASSET__8a4b7bcc__"